import React, { useState } from "react";
import "./contactform.scss";
import { Fade, Zoom } from "react-reveal";
export default function Form() {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const handleOnChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: "" });
  };
  const handleOnClick = (e) => {
    e?.preventDefault();
    const requiredFields = ["First_Name", "Last_Name", "Message"];
    const newErrors = {};
    let hasError = false;
    requiredFields.forEach((el) => {
      if (!data[el]) {
        newErrors[el] = `${el} is required`;
        hasError = true;
      }
    });

    if (hasError) {
      setError(newErrors);
      return;
    }
    const existingData = JSON.parse(localStorage.getItem("Data")) || [];
    const newData = [...existingData, data];
    localStorage.setItem("Data", JSON.stringify(newData));
    setData({
      First_Name: "",
      Last_Name: "",
      Message: "",
    });
  };
  return (
    <section className="contact_page">
      <div className="container">
        <Fade bottom duration={600} delay={400}>
          <h1
            className="contact_page_heading"
            title="Let’s Start a conversation"
          >
            Let’s Start a conversation
          </h1>
        </Fade>
        <div className="main-grid-form">
          <div className="conver-text">
            <Fade bottom duration={600} delay={400}>
              <h2 title="Ask how we can help you">Ask how we can help you:</h2>
            </Fade>
            <Fade bottom duration={700} delay={500}>
              <p>
                "Ask How Can We Help You" embodies our commitment to
                understanding and addressing your unique needs. Drop a message
                to reach out and share your queries, challenges, or goals with
                us. Whether you're seeking guidance on leveraging AI technology,
                exploring partnership opportunities, or inquiring about our
                services, we're here to provide personalized assistance tailored
                to your specific requirements.
              </p>
            </Fade>
            <Fade bottom duration={800} delay={600}>
              <p>
                At Vedhas AI Technologies, we prioritize your satisfaction and
                success. By initiating this conversation, you enable us to
                better comprehend your needs and offer relevant solutions. So
                don't hesitate to reach out and ask how we can assist you. We're
                eager to listen, collaborate, and work together towards
                achieving your objectives effectively.
              </p>
            </Fade>
          </div>

          <div className="conver-form">
            <Zoom>
              <form>
                <div className="lable">First Name</div>
                <div className="input-name">
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    name="First_Name"
                    required
                    onChange={(e) => handleOnChange(e)}
                    value={data?.First_Name}
                  />
                  {error.First_Name && <p>{error.First_Name}</p>}
                </div>

                <div className="lable">Last Name</div>
                <div className="input-name">
                  <input
                    type="text"
                    placeholder="Enter Last Name"
                    name="Last_Name"
                    required
                    onChange={(e) => handleOnChange(e)}
                    value={data?.Last_Name}
                  />
                  {error.Last_Name && <p>{error.Last_Name}</p>}
                </div>

                <div className="lable">Message</div>
                <div className="input-name">
                  <textarea
                    placeholder="Start Typing Your message"
                    name="Message"
                    required
                    onChange={(e) => handleOnChange(e)}
                    value={data?.Message}
                  ></textarea>
                  {error.Message && <p>{error.Message}</p>}
                </div>
                <Fade bottom duration={900} delay={700}>
                  <button onClick={(e) => handleOnClick(e)}>Send</button>
                </Fade>
              </form>
            </Zoom>
          </div>
        </div>
      </div>
    </section>
  );
}
